import { render, staticRenderFns } from "./PanelSunburst.vue?vue&type=template&id=366ad3d7&scoped=true&"
import script from "./PanelSunburst.vue?vue&type=script&lang=js&"
export * from "./PanelSunburst.vue?vue&type=script&lang=js&"
import style0 from "./PanelSunburst.vue?vue&type=style&index=0&id=366ad3d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ad3d7",
  null
  
)

export default component.exports